const MAX_INITIALS = 2;

/** "Maya Reyes" → "MR"; falls back to the email's local part ("dev@example.com" → "D"). */
export const userInitials = (user: { name?: string; email?: string }): string => {
	const name = user.name?.trim();
	// Some accounts carry the email as the name.
	// A blank name counts as missing, so the email still supplies initials.
	const source = (name && !name.includes("@") ? name : (name || user.email)?.split("@")[0]) || "";
	const words = source.split(/[\s._-]+/).filter(Boolean);
	return words
		.slice(0, MAX_INITIALS)
		.map(word => word[0]?.toUpperCase() ?? "")
		.join("");
};
